import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { jsx } from '@emotion/core';
import { Component } from 'react';
import { PROPS_TO_FILTER } from './constants';
import { getInputPaddingLeft } from './styles';
import { validatePhone } from './validatePhone';
import { FloatingLabelInput } from '../../FloatingLabelInput';
import { withCursorTracking } from '../../../HigherOrderComponents';
import { DialingCode, PhoneInputContainer } from './styledComponents';
import { formatPhonePattern, getMaskedPhoneNumber } from '../phoneUtils';
import { filterProps, isFunction, stripNonDigits } from '../../../../utils';
import { rtlNumberOnlyStyles } from '../../commonStyles';

class PhoneInputBase extends Component {
  constructor() {
    super(...arguments);

    _defineProperty(this, "changeHandler", e => {
      e.persist();
      var {
        target: {
          value
        }
      } = e;
      var {
        changeHandler,
        value: oldValue
      } = this.props;
      var newValue = stripNonDigits(value);

      if (isFunction(changeHandler)) {
        var isMaxLength = value.length === e.target.maxLength;
        var validation = validatePhone(newValue, {
          props: this.props
        });
        changeHandler(e, newValue, oldValue, {
          isMaxLength,
          validation
        });
      }
    });
  }

  render() {
    var {
      dialingCode,
      dialingCodeLabel,
      dialingCodeStyleOverrides,
      inputStyleOverrides,
      mask,
      pattern,
      value,
      withoutDialingCode
    } = this.props;
    var inputProps = filterProps(this.props, PROPS_TO_FILTER);
    var maskedValue = mask !== null && mask !== void 0 && mask.length ? getMaskedPhoneNumber(value, mask) : value;
    var htmlPattern = pattern && formatPhonePattern(pattern);
    return jsx(PhoneInputContainer, null, !withoutDialingCode && jsx(DialingCode, {
      "aria-label": dialingCodeLabel,
      css: dialingCodeStyleOverrides,
      "data-testid": "dialing-code"
    }, "+", dialingCode), jsx(FloatingLabelInput, _extends({}, inputProps, {
      autoComplete: "tel",
      changeHandler: this.changeHandler,
      forceFloat: !withoutDialingCode,
      id: "phone",
      inputStyleOverrides: [!withoutDialingCode && getInputPaddingLeft(dialingCode), rtlNumberOnlyStyles, inputStyleOverrides],
      pattern: htmlPattern,
      type: "tel",
      value: maskedValue
    })));
  }

}

var PhoneInput = withCursorTracking(PhoneInputBase, stripNonDigits);
export { PhoneInput, PhoneInputBase };